import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { TRANSCODE_ERROR_MSG, TRANSCODE_TIME_OUT, API_TIMEOUT_ERROR_MSG, SERVER_ERROR_MSG } from '../../common/const';
import { noop } from '../../common/utils';
export var VideoValidateKey;
(function (VideoValidateKey) {
  VideoValidateKey["VIDEO_MEDIA_WIDTH"] = "VIDEO_MEDIA_WIDTH";
  VideoValidateKey["VIDEO_MEDIA_HEIGHT"] = "VIDEO_MEDIA_HEIGHT";
  VideoValidateKey["VIDEO_MEDIA_ASPECTRATIO"] = "VIDEO_MEDIA_ASPECTRATIO";
  VideoValidateKey["VIDEO_MEDIA_DURATION"] = "VIDEO_MEDIA_DURATION";
})(VideoValidateKey || (VideoValidateKey = {}));
export var TransferStatus;
(function (TransferStatus) {
  TransferStatus["SUCCESS"] = "MEDIA_STATUS_VALID";
  TransferStatus["PENDING"] = "MEDIA_STATUS_PENDING";
})(TransferStatus || (TransferStatus = {}));
export var VideoUploadStatus;
(function (VideoUploadStatus) {
  VideoUploadStatus["SUCCESS"] = "success";
  VideoUploadStatus["ERROR"] = "error";
  VideoUploadStatus["FAIL"] = "fail";
  VideoUploadStatus["PENDING"] = "pending";
  VideoUploadStatus["CANCEL"] = "cancel";
})(VideoUploadStatus || (VideoUploadStatus = {}));
export function videoUploadRequest(opt) {
  var url = opt.url,
    request = opt.request,
    requestData = opt.requestData;
  var abortRef = {
    abort: noop
  };
  var abort = function abort() {
    return abortRef.abort();
  };
  var requestResult = request.post(url, requestData, {
    cancelToken: new request.CancelToken(function (cancel) {
      return abortRef.abort = cancel;
    }),
    timeout: TRANSCODE_TIME_OUT,
    timeoutErrorMessage: API_TIMEOUT_ERROR_MSG,
    withCredentials: true,
    showErrorToast: false
  }).then(function (res) {
    var _a;
    var _ref = res || {},
      code = _ref.code,
      data = _ref.data;
    if (code !== 0) {
      return {
        status: VideoUploadStatus.ERROR,
        value: SERVER_ERROR_MSG
      };
    }
    var transcodedMediaList = data.transcoded_media_list,
      notMatchInfoList = data.not_match_info_list;
    if (notMatchInfoList.length > 0) {
      return {
        status: VideoUploadStatus.FAIL,
        value: (_a = notMatchInfoList[0]) === null || _a === void 0 ? void 0 : _a.not_match_item_list
      };
    }
    var item = transcodedMediaList[0];
    var transcodeStatus = item.transcode_status;
    if (transcodeStatus === TransferStatus.PENDING) {
      return {
        status: VideoUploadStatus.PENDING
      };
    }
    if (transcodeStatus === TransferStatus.SUCCESS) {
      var mpSrc = item.media_url,
        vid = item.original_media_vid,
        materialId = item.transcode_media_id,
        originalMaterialId = item.original_media_id;
      if (mpSrc && vid && materialId && originalMaterialId) {
        var videoName = /\.mp4$/.test(mpSrc) ? mpSrc : "".concat(mpSrc, ".mp4");
        return {
          status: VideoUploadStatus.SUCCESS,
          value: _objectSpread(_objectSpread({}, item), {}, {
            video_name: videoName
          })
        };
      }
    }
    return {
      status: VideoUploadStatus.ERROR,
      value: TRANSCODE_ERROR_MSG
    };
  }).catch(function (err) {
    if (request.isCancel(err)) {
      return {
        status: VideoUploadStatus.CANCEL
      };
    }
    return {
      status: VideoUploadStatus.ERROR,
      value: TRANSCODE_ERROR_MSG
    };
  });
  return {
    requestResult: requestResult,
    abort: abort
  };
}